import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { CommonService } from "src/app/shared/services/common.service";
import { LifecycleService } from "src/app/shared/services/lifecycle.service";

@Component({
    selector: "app-decision-workflow-step",
    templateUrl: "./decision-workflow-step.component.html",
    styleUrls: ["./decision-workflow-step.component.scss"],
    standalone: false
})
export class DecisionWorkflowStepComponent implements OnInit {
  @Input() decisionFormChange: any;
  @Input() verdicts: string[] = [];
  @Input() tasks: { stepid: string; stepname: string }[] = [];
  @Input() workflowId;
  @Input() taskAction: { stepid: string; stepname: string }[] = [];
  validations_form: UntypedFormGroup;
  taskNames: string[] = [];
  conditionTypeOptions = [
    { label: "All conditions are met", value: "ALL" },
    { label: "Any conditions are met", value: "ANY" },
  ];
  dynamicFields: string[] = [];
  sources: string[] = ["Field", "Task"];

  fieldsMap: any = {
    Field: ["Age", "Salary", "Department"],
    Task: ["Status", "Priority", "Owner"],
    User: ["Role", "Country"],
  };

  operatorsList: string[] = [
    "Is Equals",
    "Is Greater Than",
    "Is Less Than",
    "Is Not Equal",
    "Is Blank",
    "Is Not Blank",
  ];

  constructor(
    private fb: FormBuilder,
    private lifecycleservice: LifecycleService,private commonService:CommonService
  ) {}

  /**
   * @Author Shyam
   * @Date 26/03/2026
   *  @Description: Decision workflow steps Component
   */
  ngOnInit(): void {
    this.validations_form = this.fb.group({
      rules: this.fb.array([]),
    });
    // this.commonService.getlookupVauleByLookUpType("Mapping Type").subscribe(result => {
    //   console.log(result);
    //   this.mappingTypeDataDropDown = result;
    //   console.log(this.mappingTypeDataDropDown)

    // });
    this.updateTaskNames();
    this.lifecycleservice
      .retrieveJSuiteObjectsByWorkflowAndLifecycleId(this.workflowId)
      .subscribe((response) => {
        console.log(response);
        if (response) {
          const attributes = JSON.parse(response.attributes);
          console.log(attributes);
          this.dynamicFields = attributes.map((attr: any) => attr.Field);
          console.log("Dynamic Fields:", this.dynamicFields);
          if (this.decisionFormChange) {
            this.loadData();
          } else {
            this.addRule();
          }
        } else {
          // fallback if dynamicFields not returned
          if (!this.decisionFormChange) {
            this.addRule();
          }
        }
      });
    // if (this.decisionFormChange) {
    //   this.loadData();
    // }else{
    //   this.addRule()
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("Incoming decision data:", this.decisionFormChange);
    if (changes["decisionFormChange"] && this.validations_form) {
      this.loadData();
    }
    if (changes["taskAction"]) {
      console.log("Incoming tasks:", this.taskAction);
      this.updateTaskNames();
    }
  }

  loadData() {
    this.rules.clear(); // VERY IMPORTANT
    console.log("Rules", this.rules);
    console.log("Rules value", this.rules.value);
    if (this.decisionFormChange?.rules?.length) {
      this.decisionFormChange.rules.forEach((rule: any) => {
        this.rules.push(this.createRuleWithData(rule));
      });
    } else {
      this.addRule();
    }
  }

  createRuleWithData(ruleData: any): UntypedFormGroup {
    const group = this.fb.group({
      conditionType: [
        Array.isArray(ruleData.conditionType)
          ? ruleData.conditionType[0]
          : ruleData.conditionType || "ALL",
      ],
      thenAction: [ruleData.then?.action || ""],
      conditions: this.fb.array(
        ruleData.conditions.map((c: any) => {
          let fields = this.fieldsMap[c.source] || [];
          let stepName = c.field;
          if (c.source === "Field") {
            fields = this.dynamicFields.length ? this.dynamicFields : [];
          } else if (c.source === "Task") {
            fields = this.taskAction?.map((task) => task.stepname) || [];
             stepName = this.taskAction?.find((t) => t.stepid === c.field)?.stepname || c.field;
          }
          return this.fb.group({
            selectedSource: [c.source],
            selectedField: stepName,
            selectedOperator: [c.operator],
            value: [c.value],
            fields: [fields],
            operators: [this.operatorsList],
            stepId: [c.stepId || ''] 
          });
        }),
      ),
    });

    return group;
  }

  addRule() {
    this.rules.push(this.createRule());
  }

  removeRule(index: number) {
    this.rules.removeAt(index);
  }

  createRule(): UntypedFormGroup {
    return this.fb.group({
      conditionType: ["All conditions are met"],
      conditions: this.fb.array([this.createCondition()]),
      thenAction: [""],
    });
  }
  createCondition(): UntypedFormGroup {
    return this.fb.group({
      selectedSource: [""],
      selectedField: [""],
      selectedOperator: [""],
      value: [""],
      fields: [[]],
      stepId: [''],
      operators: [this.operatorsList],
    });
  }
  get rules(): FormArray {
    return this.validations_form.get("rules") as FormArray;
  }

  onSourceChange(ruleIndex: number, conditionIndex: number) {
    const condition = this.getConditions(ruleIndex).at(conditionIndex);
    const selectedSource = condition.get("selectedSource")?.value;
    let fields = [];

    if (selectedSource === "Field") {
      fields = this.dynamicFields;
    } else if (selectedSource === "Task") {
      // Populate with step names from tasks input
      fields = this.taskAction.map((task) => task.stepname);
    } else {
      fields = this.fieldsMap[selectedSource] || [];
    }

    condition.patchValue({
      selectedField: "",
      selectedOperator: "",
      value: "",
    });

    condition.get("fields")?.setValue(fields);
    condition.get("operators")?.setValue([]);
  }

  onFieldChange(ruleIndex: number, conditionIndex: number) {
    const condition = this.getConditions(ruleIndex).at(conditionIndex);
    const selectedField = condition.get("selectedField")?.value;
    // const ops = this.operatorsMap[selectedField] || [];
    const selectedSource = condition.get("selectedSource")?.value;
    condition.patchValue({
      selectedOperator: "",
      value: "",
    });

    condition.get("operators")?.setValue(this.operatorsList);
    if (selectedSource === "Task") {
      const step = this.taskAction.find((t) => t.stepname === selectedField);
      if (step) {
        condition.patchValue({ stepId: step.stepid });
      }
    }
  }

  sendData() {
    const raw = this.validations_form.value;

    return {
      rules: raw.rules.map((rule) => ({
        conditionType: [rule.conditionType],
        conditions: rule.conditions.map((c) => ({
          source: c.selectedSource,
          field: c.selectedSource === "Task" ? c.stepId : c.selectedField,
          operator: c.selectedOperator,
          value: c.value,
        })),
        then: {
          action: rule.thenAction,
        },
      })),
    };
  }

  setFormData(data: any) {
    console.log(data);
    if (!data) return;
    this.validations_form.patchValue(data);
  }

  getConditions(ruleIndex: number): FormArray {
    return this.rules.at(ruleIndex).get("conditions") as FormArray;
  }
  addCondition(ruleIndex: number) {
    this.getConditions(ruleIndex).push(this.createCondition());
  }

  removeCondition(ruleIndex: number, conditionIndex: number) {
    const conditions = this.getConditions(ruleIndex);

    if (conditions.length > 1) {
      conditions.removeAt(conditionIndex);
    }
  }
  isConditionComplete(condition: any): boolean {
    return !!(
      condition.get("selectedSource")?.value &&
      condition.get("selectedField")?.value &&
      condition.get("selectedOperator")?.value &&
      condition.get("value")?.value
    );
  }

  isLastConditionComplete(ruleIndex: number): boolean {
    const conditions = this.getConditions(ruleIndex);
    const last = conditions.at(conditions.length - 1);
    return this.isConditionComplete(last);
  }

  getStepIdByName(stepName: string): string | undefined {
    return this.tasks?.find((ts) => ts.stepname === stepName)?.stepid;
  }

  updateTaskNames(): void {
    console.log(this.tasks);
    this.taskNames = this.tasks?.map((task) => task.stepname) || [];
  }
}
